import React from 'react'
import "../css/boletines.css"
import Contenido2 from '../components/Contenido2/Contenido2'

const Boletines = props => {
    return (
        <div>
            <header>
                <div className="contenedorSeccion">
                    <div className="tituloSeccion">
                        <Contenido2 data={props.data}
                            parrafoUno={props.data.secciones.boletines.nombre}
                        />
                    </div>
                </div>
            </header>

            <main>
                <section className="boletines">
                                    <div className="contenedorInterno">
                        <div className="imagen21" />
                        <div className="contenedorListaBoletines19">
                            <ul>
                           
                                <a href="http://rasc.mx/Boletines/CircularOCT21RyA.pdf" target="_blank" className="listaBoletines">
                                    <li>
                                        <Contenido2 data={props.data}
                                            parrafoUno={props.data.secciones.boletines.p2021.p1}
                                        />
                                    </li>
                                </a>
                                <a href="http://rasc.mx/Boletines/CircularSEP21RyA.pdf" target="_blank" className="listaBoletines">
                                    <li>
                                        <Contenido2 data={props.data}
                                            parrafoUno={props.data.secciones.boletines.p2021.p2}
                                        />
                                    </li>
                                </a>


                                 <a href="http://rasc.mx/Boletines/CircularAGO21RyA.pdf" target="_blank" className="listaBoletines">
                                    <li>
                                        <Contenido2 data={props.data}
                                            parrafoUno={props.data.secciones.boletines.p2021.p3}
                                        />
                                    </li>
                                </a>
                                 <a href="http://rasc.mx/Boletines/CircularJUL21RyA.pdf" target="_blank" className="listaBoletines">
                                    <li>
                                        <Contenido2 data={props.data}
                                            parrafoUno={props.data.secciones.boletines.p2021.p4}
                                        />
                                    </li>
                                </a>
                                <a href="http://rasc.mx/Boletines/CircularJUN21RyA.pdf" target="_blank" className="listaBoletines">
                                    <li>
                                        <Contenido2 data={props.data}
                                            parrafoUno={props.data.secciones.boletines.p2021.p5}
                                        />
                                    </li>
                                </a>
                                <a href="http://rasc.mx/Boletines/CircularMAY21RyA.pdf" target="_blank" className="listaBoletines">
                                    <li>
                                        <Contenido2 data={props.data}
                                            parrafoUno={props.data.secciones.boletines.p2021.p6}
                                        />
                                    </li>
                                </a>
                                  <a href="http://rasc.mx/Boletines/CircularABR21RyA.pdf" target="_blank" className="listaBoletines">
                                    <li>
                                        <Contenido2 data={props.data}
                                            parrafoUno={props.data.secciones.boletines.p2021.p7}
                                        />
                                    </li>
                                </a>
                                <a href="http://rasc.mx/Boletines/CircularMAR21RyA.pdf" target="_blank" className="listaBoletines">
                                    <li>
                                        <Contenido2 data={props.data}
                                            parrafoUno={props.data.secciones.boletines.p2021.p8}
                                        />
                                    </li>
                                </a>
                                  <a href="http://rasc.mx/Boletines/CircularFEB21RyA.pdf" target="_blank" className="listaBoletines">
                                    <li>
                                        <Contenido2 data={props.data}
                                            parrafoUno={props.data.secciones.boletines.p2021.p9}
                                        />
                                    </li>
                                </a>
                                <a href="http://rasc.mx/Boletines/CircularENE21RyA.pdf" target="_blank" className="listaBoletines">
                                    <li>
                                        <Contenido2 data={props.data}
                                            parrafoUno={props.data.secciones.boletines.p2021.p10}
                                        />
                                    </li>
                                </a>
                               
                            </ul>
                        </div>
                    </div>
                    <div className="contenedorInternoDos">
                        <div className="imagen20" />
                        <div className="contenedorListaBoletines19">
                            <ul>
                                <a href="http://rasc.mx/Boletines/circular_02_2020.pdf" target="_blank" className="listaBoletines">
                                    <li>
                                        <Contenido2 data={props.data}
                                            parrafoUno={props.data.secciones.boletines.p2020.p1}
                                        />
                                    </li>
                                </a>
                                <a href="http://rasc.mx/Boletines/circular_01_2020.pdf" target="_blank" className="listaBoletines">
                                    <li>
                                        <Contenido2 data={props.data}
                                            parrafoUno={props.data.secciones.boletines.p2020.p2}
                                        />
                                    </li>
                                </a>
                               
                            </ul>
                        </div>
                    </div>

                    <div className="contenedorInterno">
                        <div className="imagen19" />
                        <div className="contenedorListaBoletines19">
                            <ul>
                                <a href="http://rasc.mx/Boletines/circular_12_19.pdf" target="_blank" className="listaBoletines">
                                    <li>
                                        <Contenido2 data={props.data}
                                            parrafoUno={props.data.secciones.boletines.p2019.p1}
                                        />
                                    </li>
                                </a>
                                <a href="http://rasc.mx/Boletines/circular_11_19.pdf" target="_blank" className="listaBoletines">
                                    <li>
                                        <Contenido2 data={props.data}
                                            parrafoUno={props.data.secciones.boletines.p2019.p2}
                                        />
                                    </li>
                                </a>
                                <a href="http://rasc.mx/Boletines/CircularMarzo19R&A.pdf" target="_blank" className="listaBoletines">
                                    <li>
                                        <Contenido2 data={props.data}
                                            parrafoUno={props.data.secciones.boletines.p2019.p3}
                                        />
                                    </li>
                                </a>
                                  <a href="http://rasc.mx/Boletines/CircularFeb19R&A.pdf" target="_blank" className="listaBoletines">
                                    <li>
                                        <Contenido2 data={props.data}
                                            parrafoUno={props.data.secciones.boletines.p2019.p4}
                                        />
                                    </li>
                                </a>
                                  <a href="http://rasc.mx/Boletines/CircularEne19R&A.pdf" target="_blank" className="listaBoletines">
                                    <li>
                                        <Contenido2 data={props.data}
                                            parrafoUno={props.data.secciones.boletines.p2019.p5}
                                        />
                                    </li>
                                </a>
                            </ul>
                        </div>
                    </div>
                    <div className="contenedorInternoDos">
                        <div className="imagen18" />
                        <div className="contenedorListaBoletines18">
                            <ul>
                                <a href="http://rasc.mx/Boletines/CircularDic18R&A.pdf" target="_blank" className="listaBoletines">
                                    <li>
                                        <Contenido2 data={props.data}
                                            parrafoUno={props.data.secciones.boletines.p2018.p1}
                                        />
                                    </li>
                                </a>
                                <a href="http://rasc.mx/Boletines/CircularNov18R&A.pdf" target="_blank" className="listaBoletines">
                                    <li>
                                        <Contenido2 data={props.data}
                                            parrafoUno={props.data.secciones.boletines.p2018.p2}
                                        />
                                    </li>
                                </a>
                                <a href="http://rasc.mx/Boletines/CircularOct18R&A.pdf" target="_blank" className="listaBoletines">
                                    <li>
                                        <Contenido2 data={props.data}
                                            parrafoUno={props.data.secciones.boletines.p2018.p3}
                                        />
                                    </li>
                                </a>
                                <a href="http://rasc.mx/Boletines/CircularSept18R&A.pdf" target="_blank" className="listaBoletines">
                                    <li>
                                        <Contenido2 data={props.data}
                                            parrafoUno={props.data.secciones.boletines.p2018.p4}
                                        />
                                    </li>
                                </a>
                                <a href="http://rasc.mx/Boletines/CircularAg18R&A.pdf" target="_blank" className="listaBoletines">
                                    <li>
                                        <Contenido2 data={props.data}
                                            parrafoUno={props.data.secciones.boletines.p2018.p5}
                                        />
                                    </li>
                                </a>
                                <a href="http://rasc.mx/Boletines/CircularJul18R&A.pdf" target="_blank" className="listaBoletines">
                                    <li>
                                        <Contenido2 data={props.data}
                                            parrafoUno={props.data.secciones.boletines.p2018.p6}
                                        />
                                    </li>
                                </a>
                                <a href="http://rasc.mx/Boletines/CircularJun18R&A.pdf" target="_blank" className="listaBoletines">
                                    <li>
                                        <Contenido2 data={props.data}
                                            parrafoUno={props.data.secciones.boletines.p2018.p7}
                                        />
                                    </li>
                                </a>
                                <a href="http://rasc.mx/Boletines/CircularMayo18R&A.pdf" target="_blank" className="listaBoletines">
                                    <li>
                                        <Contenido2 data={props.data}
                                            parrafoUno={props.data.secciones.boletines.p2018.p8}
                                        />
                                    </li>
                                </a>
                                <a href="http://rasc.mx/Boletines/CircularAbril18R&A.pdf" target="_blank" className="listaBoletines">
                                    <li>
                                        <Contenido2 data={props.data}
                                            parrafoUno={props.data.secciones.boletines.p2018.p9}
                                        />
                                    </li>
                                </a>
                                <a href="http://rasc.mx/Boletines/CircularMzo18R&A.pdf" target="_blank" className="listaBoletines">
                                    <li>
                                        <Contenido2 data={props.data}
                                            parrafoUno={props.data.secciones.boletines.p2018.p10}
                                        />
                                    </li>
                                </a>
                                <a href="http://rasc.mx/Boletines/CircularFeb18R&A.pdf" target="_blank" className="listaBoletines">
                                    <li>
                                        <Contenido2 data={props.data}
                                            parrafoUno={props.data.secciones.boletines.p2018.p11}
                                        />
                                    </li>
                                </a>
                                <a href="http://rasc.mx/Boletines/CircularEn18R&A.pdf" target="_blank" className="listaBoletines">
                                    <li>
                                        <Contenido2 data={props.data}
                                            parrafoUno={props.data.secciones.boletines.p2018.p12}
                                        />
                                    </li>
                                </a>
                            </ul>
                        </div>
                    </div>
                    <div className="contenedorInterno">
                        <div className="imagen17" />
                        <div className="contenedorListaBoletines17">
                            <ul>
                               
                                <a href="http://rasc.mx/Boletines/CircularDic17R&A.pdf" target="_blank" className="listaBoletines">
                                    <li>
                                        <Contenido2 data={props.data}
                                            parrafoUno={props.data.secciones.boletines.p2017.p2}
                                        />
                                    </li>
                                </a>
                                 <a href="http://rasc.mx/Boletines/CircularNov17R&A.pdf" target="_blank" className="listaBoletines">
                                    <li>
                                        <Contenido2 data={props.data}
                                            parrafoUno={props.data.secciones.boletines.p2017.p1}
                                        />
                                    </li>
                                </a>
                            </ul>
                        </div>
                    </div>
                </section>
            </main>
        </div>
    )
}

export default Boletines;